import { DefaultTheme } from 'styled-components'

export const fanduelCasino: DefaultTheme = {
  name: 'Fanduel Casino',
  fontFamily: "'ProximaNovaRegular', Arial",
  productTheme: 'default',
  mediaQueries: {
    extraLarge: {
      minWidth: '1478px',
    },
    large: {
      maxWidth: '1024px',
    },
    tablet: {
      maxWidth: '964px',
    },
    mobile: {
      maxWidth: '730px',
    },
  },
  pageTitle: {
    text: {
      size: '18px',
      color: '#445058',
      weight: 'bold',
    },
  },
  breadcrumbs: {
    text: {
      size: '14px',
      color: '#445058',
      weight: 'bold',
    },
    lastItemText: {
      size: '14px',
      color: '#445058',
      weight: 'normal',
    },
  },
  card: {
    container: {
      background: {
        color: '#FFFFFF',
      },
      hover: {
        opacity: '0.75',
      },
      border: {
        radius: '4px',
        thickness: '1px',
        color: '#CFD6DB',
        style: 'solid',
      },
    },
    title: {
      text: {
        color: '#1493FF',
        size: '16px',
        weight: 'bold',
      },
    },
    description: {
      text: {
        color: '#445058',
        size: '14px',
        weight: 'normal',
        fontFamily: "'ProximaNovaRegular', Arial",
      },
    },
    footer: {
      weight: 'normal',
      fontFamily: "'ProximaNovaRegular', Arial",
    },
    overlay: {
      background: { color: 'rgba(0, 0, 0, 0.8)' },
      text: { color: '#ffffff', weight: 'normal', size: '14px' },
    },
  },
  button: {
    primary: {
      gradient: {
        direction: 'to bottom',
        start: '#32B964',
        end: '#189F4A',
      },
      border: {
        color: 'transparent',
        thickness: '0',
        radius: '4px',
        style: 'solid',
      },
      text: {
        color: '#FFFFFF',
        weight: 'normal',
        size: '16px',
      },
      hover: {
        background: {
          color: '#189F4A',
        },
        text: {
          color: '#FFFFFF',
          weight: 'normal',
          size: '16px',
        },
      },
      disabled: {
        background: {
          color: '#E4E8EE',
        },
        text: {
          color: '#B9C4CB',
          weight: 'normal',
          size: '16px',
        },
      },
      active: {
        background: {
          color: '#137C39',
        },
        text: {
          color: '#FFFFFF',
          weight: 'normal',
          size: '16px',
        },
      },
    },
    secondary: {
      gradient: {
        direction: 'to bottom',
        start: '#1493FF',
        end: '#1381E0',
      },
      border: {
        color: 'transparent',
        thickness: '0',
        radius: '4px',
        style: 'solid',
      },
      text: {
        color: '#FFFFFF',
        weight: 'normal',
        size: '16px',
      },
      hover: {
        background: {
          color: '#1381E0',
        },
        text: {
          color: '#FFFFFF',
          weight: 'normal',
          size: '16px',
        },
      },
      active: {
        background: {
          color: '#0E67B3',
        },
        text: {
          color: '#FFFFFF',
          weight: 'normal',
          size: '14px',
        },
      },
      disabled: {
        background: {
          color: '#E4E8EE',
        },
        text: {
          color: '#B9C4CB',
          weight: 'normal',
          size: '16px',
        },
      },
    },
    outline: {
      background: {
        color: 'transparent',
      },
      border: {
        color: '#1493FF',
        radius: '4px',
        thickness: '1px',
        style: 'solid',
      },
      text: {
        color: '#1381E0',
        size: '16px',
        weight: 'normal',
      },
      active: {
        text: {
          color: '#FFFFFF',
          size: '16px',
          weight: 'normal',
        },
        background: {
          color: '#1493FF',
        },
      },
      disabled: {
        background: {
          color: '#E4E8EE',
        },
        text: {
          color: '#B9C4CB',
          weight: 'normal',
          size: '16px',
        },
      },
      hover: {
        background: {
          color: '#F5F8FC',
        },
        text: {
          color: '#1493FF',
          size: '16px',
          weight: 'normal',
        },
      },
    },
    text: {
      background: {
        color: 'transparent',
      },
      border: {
        color: 'transparent',
        thickness: '0',
        radius: '4px',
        style: 'solid',
      },
      text: {
        color: '#1381E0',
        size: '16px',
        weight: 'normal',
      },
      active: {
        text: {
          color: '#FFFFFF',
          size: '16px',
          weight: 'normal',
        },
        background: {
          color: '#1493FF',
        },
      },
      disabled: {
        background: {
          color: '#E4E8EE',
        },
        text: {
          color: '#B9C4CB',
          weight: 'normal',
          size: '16px',
        },
      },
      hover: {
        background: {
          color: 'transparent',
        },
        text: {
          color: '#0E67B3',
          size: '16px',
          weight: 'normal',
        },
      },
    },
  },
  badge: {
    notAvailable: {
      background: {
        color: '#e72931',
      },
      text: {
        color: '#ffffff',
        weight: 'normal',
        size: '12px',
        fontFamily: "'ProximaNovaCondensed', 'ProximaNovaRegular', Arial",
      },
    },
    expired: {
      background: {
        color: '#CFD6DB',
      },
      text: {
        color: '#445058',
        weight: 'normal',
        size: '12px',
        fontFamily: "'ProximaNovaCondensed', 'ProximaNovaRegular', Arial",
      },
    },
    bonusUsed: {
      background: {
        color: '#CFD6DB',
      },
      text: {
        weight: 'normal',
        color: '#445058',
        size: '12px',
        fontFamily: "'ProximaNovaCondensed', 'ProximaNovaRegular', Arial",
      },
    },
    accepted: {
      background: {
        color: '#2CB459',
      },
      text: {
        color: '#ffffff',
        weight: 'normal',
        size: '12px',
        fontFamily: "'ProximaNovaCondensed', 'ProximaNovaRegular', Arial",
      },
    },
    qualified: {
      background: {
        color: '#2CB459',
      },
      text: {
        color: '#ffffff',
        weight: 'normal',
        size: '12px',
        fontFamily: "'ProximaNovaCondensed', 'ProximaNovaRegular', Arial",
      },
    },
    bonusAwarded: {
      background: {
        color: '#ffcb4d',
      },
      text: {
        color: '#244368',
        weight: 'normal',
        size: '12px',
        fontFamily: "'ProximaNovaCondensed', 'ProximaNovaRegular', Arial",
      },
    },
    completed: {
      background: {
        color: '#2CB459',
      },
      text: {
        color: '#ffffff',
        weight: 'normal',
        size: '12px',
        fontFamily: "'ProximaNovaCondensed', 'ProximaNovaRegular', Arial",
      },
    },
    comingSoon: {
      background: {
        color: '#1493FF',
      },
      text: {
        color: '#ffffff',
        weight: 'normal',
        size: '12px',
        fontFamily: "'ProximaNovaCondensed', 'ProximaNovaRegular', Arial",
      },
    },
    default: {
      background: {
        color: '#1493FF',
      },
      text: {
        color: '#ffffff',
        weight: 'normal',
        size: '12px',
        fontFamily: "'ProximaNovaCondensed', 'ProximaNovaRegular', Arial",
      },
    },
  },
  timeLeft: {
    text: {
      fontFamily: "'ProximaNovaCondensed', 'ProximaNovaRegular', Arial",
      color: '#818E95',
      size: '12px',
      weight: 'normal',
    },
  },
  radioButton: {
    button: {
      unchecked: {
        background: {
          color: '#fff',
        },
        border: {
          radius: '50%',
          thickness: '1px',
          color: '#CFD6DB',
          style: 'solid',
        },
      },
      checked: {
        background: {
          color: '#1381E0',
        },
      },
    },
    text: {
      color: '#445058',
      size: '14px',
      weight: 'normal',
    },
  },
  landing: {
    fontFamily: "'ProximaNovaRegular', Arial",
    background: {
      color: '#FFFFFF',
    },
    title: {
      text: {
        color: '#1F375B',
        size: '24px',
        weight: 'bold',
        lineHeight: '30px',
        fontFamily: "'ProximaNovaBold', Arial",
      },
    },
    description: {
      text: {
        color: '#445058',
        size: '16px',
        weight: 'normal',
        lineHeight: '23px',
      },
      bold: {
        color: '#445058',
        size: '16px',
        weight: 'normal',
        lineHeight: '23px',
        fontFamily: "'ProximaNovaBold', Arial",
      },
      table: {
        layout: 'fixed',
        borderCollapse: 'collapse',
        rowColor: '#F0F3F8',
        cellPadding: '8px',
        border: {
          radius: '0',
          thickness: '1px',
          color: '#CFD6DB',
          style: 'solid',
        },
      },
      list: {
        ordered: {
          paddingLeft: '21px',
        },
        unordered: {
          paddingLeft: '10px',
          listItem: {
            paddingLeft: '10px',
            bullet: {
              listStyle: '"\\2022"',
            },
          },
        },
      },
    },
    steps: {
      title: {
        text: {
          color: '#1F375B',
          size: '17px',
          weight: 'bold',
          fontFamily: "'ProximaNovaBold', Arial",
        },
      },
      step: {
        text: {
          color: '#445058',
          size: '16px',
          weight: 'normal',
          lineHeight: '23px',
        },
      },
      bullet: {
        text: {
          color: '#FFFFFF',
          size: '0.8rem',
          weight: 'bold',
        },
        background: {
          color: '#afbbc2',
        },
      },
      tick: {
        fill: '#1BB152',
      },
    },
    optInOptions: {
      text: {
        color: '#445058',
        size: '14px',
        weight: 'normal',
      },
      postOptIn: {
        text: {
          color: '#818E95',
          size: '14px',
          weight: 'normal',
        },
        icon: {
          fill: '#818E95',
        },
        selected: {
          text: {
            color: '#445058',
            size: '14px',
            weight: 'bold',
          },
          icon: {
            fill: '#1BB152',
          },
        },
      },
    },
    cta: {
      container: {
        color: '#FFFFFF',
      },
    },
    termsConditions: {
      title: {
        text: {
          color: '#1F375B',
          weight: 'bold',
          mobileSize: '13px',
          size: '14px',
          lineHeight: '23px',
          fontFamily: "'ProximaNovaBold', Arial",
        },
      },
      content: {
        text: {
          color: '#445058',
          weight: 'normal',
          size: '12px',
          mobileSize: '13px',
          mobileLineHeight: '18px',
          lineHeight: '15px',
        },
        bold: {
          color: '#445058',
          weight: 'normal',
          size: '12px',
          fontFamily: "'ProximaNovaBold', Arial",
        },
        table: {
          layout: 'fixed',
          borderCollapse: 'collapse',
          rowColor: '#F0F3F8',
          cellPadding: '2px',
          border: {
            radius: '0',
            thickness: '1px',
            color: '#CFD6DB',
            style: 'solid',
          },
        },
        list: {
          ordered: {
            marginLeft: '1.4em',
          },
          unordered: {
            paddingLeft: '7px',
            marginLeft: '0.8em',
            listItem: {
              bullet: {
                listStyle: '"\\2022"',
              },
            },
          },
        },
      },
      gradient: {
        direction: 'to bottom',
        start: 'rgba(255, 255, 255, 0.0001) 0%',
        end: '#FFFFFF 78%',
      },
    },
    buttonLoader: {
      color: '#ffffff',
      gap: '5px',
      size: '0.5rem',
    },
    border: {
      radius: '4px',
      thickness: '1px',
      color: '#CFD6DB',
      style: 'solid',
    },
  },
  progressBar: {
    inProgress: {
      text: {
        align: 'center',
        color: '#445058',
        size: '14px',
        weight: 'bold',
      },
      background: {
        color: '#e4e8ee',
      },
      progressBackground: {
        color: '#1493FF',
      },
    },
    completed: {
      text: {
        align: 'center',
        color: '#1BB152',
        size: '14px',
        weight: 'bold',
      },
      background: {
        color: '#1BB152',
      },
      progressBackground: {
        color: '#1BB152',
      },
    },
  },
  loader: {
    color: '#1493FF',
  },
  errorScreen: {
    background: {
      color: 'transparent',
      image: {
        url:
          'data:image/svg+xml;base64,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',
        size: 'auto',
        repeat: 'no-repeat',
        position: 'top center',
      },
    },
    title: {
      size: '18px',
      weight: 'normal',
      color: '#445058',
    },
    message: {
      size: '14px',
      weight: 'normal',
      color: '#445058',
    },
    padding: {
      top: '185px',
    },
    container: {
      padding: {
        top: '35px',
        bottom: '15px',
      },
      margin: {
        right: 'auto',
        left: 'auto',
      },
      background: {
        color: 'transparent',
      },
    },
  },
  promotionsHub: {
    itemsList: {
      columnGap: '16px',
    },
    buttonLoader: {
      color: '#ffffff',
      gap: '5px',
      size: '0.5em',
      boxPadding: {
        all: '0.4rem',
      },
    },
  },
}
